var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"keyboard-row-letter",attrs:{"id":_vm.letter,"disabled":_vm.disabled},on:{"click":function($event){return _vm.clicked()}}},[_vm._v(_vm._s(_vm.letter))])}
var staticRenderFns = []

export { render, staticRenderFns }